"use strict";

exports.__esModule = true;
exports.MapPartKindUserAction = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _MapPartKindUserActionElement = require("./MapPartKindUserActionElement");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MapPartKindUserAction = exports.MapPartKindUserAction = {
  name: "MapPartKind",
  icon: "cog",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "MapPartKindUserAction.label",
    defaultMessage: "Map Part Kind"
  }),
  description: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "MapPartKindUserAction.description",
    defaultMessage: "Define Part Kind mapping"
  }),
  requiresContexts: ["device"],
  requiresProps: [],
  components: {
    Element: _MapPartKindUserActionElement.MapPartKindActionElement
  }
};